import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const Breadcrumbs = ({ items }) => {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": items.map((item, i) => ({
        "@type": "ListItem",
        "position": i + 1,
        "name": item.label,
        "item": item.href ? `https://novahomes.in${item.href}` : undefined
      }))
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.setAttribute('data-breadcrumb', 'true');
    document.head.appendChild(script);
    return () => { document.head.removeChild(script); };
  }, [items]);

  return (
    <nav aria-label="Breadcrumb" className="text-xs font-light tracking-wide" data-testid="breadcrumbs">
      <ol className="flex items-center gap-1.5 flex-wrap">
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            {i > 0 && <span className="text-white/20">/</span>}
            {item.href ? (
              <Link to={item.href} className="text-white/40 hover:text-white/70 transition-colors">{item.label}</Link>
            ) : (
              <span className="text-white/60">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
